import * as PointsToStatementCredit from '@/src/experiences/points-to-statement-credit'
import * as CardPlatform from '@/src/experiences/card-platform'

export default CardPlatform.Screens.Gate({
  Highnote: PointsToStatementCredit.Screens.Highnote.SuccessConfirmation,
  Platform: PointsToStatementCredit.Screens.SuccessConfirmation,
})
